import React, { Component } from 'react';
import PropTypes from 'prop-types';

import cx from 'classnames';
import displayName from 'component-lib/displayName';
import styles from './AppHeader.scss';
import customLogoStyles from './CustomHeaderLogo.scss';

export default class Logo extends Component {
    static displayName = displayName('AppHeader/Logo');

    static propTypes = {
        onClick: PropTypes.func.isRequired,
        customNavLogo: PropTypes.object.isRequired,
    };

    constructor(props) {
        super(props);

        this.state = { customImageLoadError: false };
    }

    handleCustomImageError = () => {
        this.setState({ customImageLoadError: true });
    };

    render() {
        const { onClick, customNavLogo } = this.props;
        const { customImageLoadError } = this.state;

        const renderCustomLogo = customNavLogo.src && !customImageLoadError;
        const renderCustomLogoFailed = customNavLogo.src && customImageLoadError;
        const renderDefaultLogo = !customNavLogo.src && !customImageLoadError;

        const className = cx({
            [customLogoStyles['global-header-logo']]:
        renderCustomLogo || renderCustomLogoFailed,
            [styles['global-header-logo']]: renderDefaultLogo,
        });

        return (
            <div
                role="presentation"
                data-action="upper-left-logo"
                data-custom-logo-src={customNavLogo.src}
                className={className}
                onClick={onClick}
            >
                {renderCustomLogo &&
                <img
                    alt=""
                    data-custom-logo-src={customNavLogo.src}
                    className={customLogoStyles['custom-nav-logo']}
                    onError={this.handleCustomImageError}
                    {...customNavLogo}
                />}
            </div>
        );
    }
}
